export default "data:video/mp2t;base64,aW1wb3J0IERldGFpbHMgZnJvbSAiLi9EZXRhaWxzLnZ1ZSI7CgpleHBvcnQgZGVmYXVsdCBEZXRhaWxzOwo="